module.exports = __webpack_public_path__ + "img/productp12.27b524eb.png";